import { render, staticRenderFns } from "./TheHeaderDropdownList.vue?vue&type=template&id=58771b60&scoped=true"
import script from "./TheHeaderDropdownList.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownList.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownList.vue?vue&type=style&index=0&id=58771b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58771b60",
  null
  
)

export default component.exports